import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Container from "@components/layout/container"
import Header from "@components/header"
import Footer from "@components/footer"
import SEO from "@components/seo"
import { useSiteMetadata } from "@hooks/use-site-metadata"
import { LinkType } from "@types/link-type"
import Consent from "./consent"
import LayoutBanner from "./layout-banner"
import { SubNavType } from "@types/sub-nav-type"

const Main = styled.main`
  display: flex;
  flex-direction: column;
  margin-top: ${props => !props.marginless && "6rem"};
`

const Layout = ({
  children,
  blogContainer,
  fullWidth,
  title,
  titleExtension,
  description,
  canonical,
  image,
  hideOverflow,
  marginless,
  background,
  seo,
  body,
  date_updated,
  landingPage,
  links,
  productOverride,
  login,
  clean = false,
  subNav,
  flat,
}) => {
  const siteMetadata = useSiteMetadata()

  return (
    <>
      {!clean && <LayoutBanner />}
      <SEO
        title={title}
        titleExtension={titleExtension}
        description={description}
        canonical={canonical}
        image={image ?? `/klipfolio-logo-share.png`}
        seo={seo}
        body={body}
        date_updated={date_updated}
      />
      {!clean && <Consent />}
      {!clean && (
        <Header
          landingPage={landingPage}
          links={links}
          productOverride={productOverride}
          login={login}
          subNav={subNav}
          flat={flat}
        />
      )}
      <Container
        background={background}
        root
        blog={blogContainer}
        fullWidth={fullWidth}
        noPadding={fullWidth}
        hideOverflow={hideOverflow}
      >
        <Main marginless={marginless}>{children}</Main>
      </Container>
      {!clean && (
        <Footer
          footerLinks={siteMetadata.footerLinks}
          copyright={siteMetadata.copyright}
        />
      )}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  blogContainer: PropTypes.bool,
  fullWidth: PropTypes.bool,
  title: PropTypes.string,
  titleExtension: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  hideOverflow: PropTypes.bool,
  marginless: PropTypes.bool,
  background: PropTypes.string,
  seo: PropTypes.object,
  body: PropTypes.string,
  date_updated: PropTypes.string,
  landingPage: PropTypes.bool,
  links: PropTypes.arrayOf(LinkType),
  productOverride: PropTypes.number,
  login: PropTypes.bool,
  clean: PropTypes.bool,
  subNav: SubNavType,
  flat: PropTypes.bool,
}

export default Layout
